if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.content = this.querySelector('[role="document"]');
      this.zoomButton = this.querySelector('[data-media-zoom]');
      this.counter = this.querySelector('[data-media-count]');
      this.controls = this.querySelector('[data-media-controls]');
      this.controls.addEventListener('pointerup', (event) => event.stopPropagation());
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-media-zoom')) this.setZoom(!this.classList.contains('is-zoomed'));
        if (button.dataset.mediaStep) this.changeMedia(Number(button.dataset.mediaStep));
      });
      this.content.addEventListener('pointerdown', (event) => {
        if (this.classList.contains('is-zoomed') || event.target.closest('deferred-media, product-model, button') || !event.isPrimary) return;
        this.gesture = { x: event.clientX, y: event.clientY, id: event.pointerId };
      });
      this.content.addEventListener('pointerup', (event) => {
        event.stopPropagation();
        const start = this.gesture;
        this.gesture = null;
        if (!start || start.id !== event.pointerId || this.classList.contains('is-zoomed')) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) this.changeMedia(dx < 0 ? 1 : -1);
      });
      this.content.addEventListener('pointercancel', () => { this.gesture = null; });
      this.content.addEventListener('dragstart', (event) => event.preventDefault());
      this.addEventListener('keydown', (event) => {
        if (event.target.closest('input, textarea, video, model-viewer')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.changeMedia(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
    }

    get items() {
      // Dawn replaces these children when a variant has its own media.
      return Array.from(this.content.children).filter((item) => item.dataset.mediaId);
    }

    show(opener) {
      if (!this.items.length) return;
      super.show(opener);
      const index = this.items.findIndex((item) => item.dataset.mediaId === opener.dataset.mediaId);
      this.activate(index < 0 ? 0 : index);
    }

    hide() {
      this.gesture = null;
      this.setZoom(false);
      if (window.matchMedia('(max-width: 749px)').matches && this.items[this.index]) {
        const gallery = document.getElementById('MediaGallery-' + this.dataset.section);
        if (gallery) gallery.setActiveMedia(this.dataset.section + '-' + this.items[this.index].dataset.mediaId, false);
      }
      super.hide();
    }

    changeMedia(step) {
      if (this.items.length < 2) return;
      this.activate((this.index + step + this.items.length) % this.items.length);
    }

    activate(index) {
      window.pauseAllMedia();
      this.index = index;
      this.items.forEach((item, i) => item.classList.toggle('active', i === index));
      const active = this.items[index];
      if (active.tagName === 'DEFERRED-MEDIA') {
        const poster = active.querySelector('img');
        const ratio = poster ? Number(poster.getAttribute('width')) / Number(poster.getAttribute('height')) : 1;
        active.style.paddingTop = '0';
        active.style.setProperty('--modal-media-ratio', Number.isFinite(ratio) && ratio > 0 ? ratio : 1);
      }
      this.setZoom(false);
      this.zoomButton.disabled = active.tagName !== 'IMG';
      this.counter.textContent = (index + 1) + ' / ' + this.items.length;
      this.controls.querySelectorAll('[data-media-step]').forEach((button) => { button.disabled = this.items.length < 2; });
      [index, (index + 1) % this.items.length, (index - 1 + this.items.length) % this.items.length].forEach((i) => {
        const item = this.items[i];
        if (item.tagName === 'IMG') { item.loading = 'eager'; item.decoding = 'async'; item.draggable = false; }
      });
      // Keep the close target aligned with the image the shopper last viewed.
      const gallery = document.querySelector('media-gallery[id="MediaGallery-' + this.dataset.section + '"]');
      const opener = gallery && Array.from(gallery.querySelectorAll('.product__media-toggle')).find((button) => button.dataset.mediaId === active.dataset.mediaId);
      if (opener) this.openedBy = opener;
    }

    setZoom(zoomed) {
      this.classList.toggle('is-zoomed', zoomed);
      this.zoomButton.textContent = zoomed ? 'Zoom out' : 'Zoom in';
      this.zoomButton.setAttribute('aria-pressed', String(zoomed));
      this.content.scrollTop = 0;
      this.content.scrollLeft = 0;
    }
  });
}
